import getPlanTypeKey from 'core/controllerPlans/getPlanTypeKey'
import { curry } from 'ramda'
import generatePlanFilter from 'utils/pivot/plan/generatePlanFilter'

const arrayFilterCoreBenefitsByPlanType = (item, name, planTypeKey, plan) => {
  if (planTypeKey === plan.planTypeKey) {
    return +item === +plan.coreBenefits[name]
  }
  return true
}

const getPlanFiltersAdditionalInfo = ({
  filterOptionsByProductType,
  filtersByProductType,
  plans,
  plansToShow,
  policies,
  period
}) => {
  const filtersToApply = []
  const newFilters = { ...filtersByProductType }
  const newOptions = { ...filterOptionsByProductType }

  // multi-carrier
  const multiCarrierPlans = Object.entries(plans)
    .map(entry => entry[1])
    .filter((plan: Plan) => plan?.multiCarrierPlan)

  // Get all the deductibles for multi-carrier plans
  const deductibles = multiCarrierPlans.map((plan: Plan) => plan.coreBenefits.deductible)
  const dedupedDeductibles = deductibles.filter(
    (value, index) => deductibles.indexOf(value) === index && value
  )

  // Get all the max out of pockets for multi-carrier plans
  const moops = multiCarrierPlans.map((plan: Plan) => plan.coreBenefits.outOfPocketMax)
  const dedupedMoops = moops.filter(
    (value, index) => moops.indexOf(value) === index && value
  )

  // Get all the coinsurances for multi-carrier plans
  const coinsuranceOptions = multiCarrierPlans.map(
    (plan: Plan) => plan.coreBenefits.userCoinsurance
  )
  const dedupedCoinsurances = coinsuranceOptions.filter(
    (value, index) => coinsuranceOptions.indexOf(value) === index && value
  )

  // Get all lifetime maximums for multi-carrier plans

  const lifetimeMaxiumums = multiCarrierPlans.map(
    (plan: Plan) => plan.coreBenefits.lifetimeMax
  )
  const dedupedMaximums = lifetimeMaxiumums.filter(
    (value, index) => lifetimeMaxiumums.indexOf(value) === index && value
  )

  newOptions.multi = {
    coinsurance: {
      type: 'one',
      values: dedupedCoinsurances
    },
    coverage: {
      type: 'one',
      values: dedupedMaximums.map(max => parseInt(max))
    },
    deductible: {
      type: 'one',
      values: dedupedDeductibles.map(deductible => parseInt(deductible))
    },
    moop: {
      type: 'one',
      values: dedupedMoops.map(moop => parseInt(moop))
    }
  }

  multiCarrierPlans.forEach((plan: Plan) => plansToShow.push(plan.planId))

  Object.keys(newOptions).forEach(type => {
    let filters = newFilters[type]
    const planId = plansToShow.find(planId => getPlanTypeKey(plans[planId]) === type)
    const plan = plans[planId]

    if (!filters && plan) {
      newFilters[type] = generatePlanFilter({
        plan,
        policies: +policies,
        period: +period
      })

      filters = newFilters[type]
    }
    if (filters) {
      filtersToApply.push(...generateBenefitsFilter(filters, type))
    }
  })

  return {
    filtersByProductType: newFilters,
    planFiltersToApply: filtersToApply,
    filterOptionsByProductType: newOptions
  }
}

function generateBenefitsFilter(filter, planTypeKey) {
  return [
    filter.moop &&
      curry(arrayFilterCoreBenefitsByPlanType)(
        filter.moop,
        'outOfPocketMax',
        planTypeKey
      ),
    filter.coinsurance &&
      curry(arrayFilterCoreBenefitsByPlanType)(
        filter.coinsurance,
        'userCoinsurance',
        planTypeKey
      ),
    filter.coverage &&
      curry(arrayFilterCoreBenefitsByPlanType)(
        filter.coverage,
        'lifetimeMax',
        planTypeKey
      ),
    filter.deductible &&
      curry(arrayFilterCoreBenefitsByPlanType)(
        filter.deductible,
        'deductible',
        planTypeKey
      )
  ]
}

export default getPlanFiltersAdditionalInfo
